/**
 * Casanuva Quick Add — kies varianten zonder de pagina te verlaten.
 *
 * Elk element met data-quick-add="<producthandle>" opent een paneel. De inhoud
 * komt van de Section Rendering API:
 *
 *     /products/<handle>?section_id=casanuva-quick-add-panel
 *
 * Dus geen nagebouwde kaart: het is dezelfde Liquid als de productpagina. De
 * kleurstalen, de prijsopmaak van de markt en de vertalingen komen daardoor
 * vanzelf goed, zonder dat deze JS daar iets van hoeft te weten.
 *
 * Wat hier wél gebeurt: openen en sluiten, een optie kiezen, en toevoegen.
 */
(function () {
  'use strict';

  var root = document.getElementById('cnv-quick-add');
  if (!root) return;

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('cnv-quick-add-config').textContent);
  } catch (e) {
    cfg = {};
  }

  // routes.root_url geeft "/en-ie" zonder slash, en "/" op de hoofdmarkt.
  // Zonder deze normalisatie wordt de URL "/en-ieproducts/...".
  var ROOT = (cfg.root || '/').replace(/\/*$/, '/');
  var SECTION = 'casanuva-quick-add-panel';

  var panel = root.querySelector('[data-qa-panel]');
  var body = root.querySelector('[data-qa-body]');
  var opener = null;      // knop waar we vandaan kwamen, voor focus-herstel
  var variants = {};      // id -> { options, available, price, compare, save }
  var chosen = [];        // gekozen waarde per optiepositie
  var quantity = 1;
  var cache = {};
  var shownMedia = null;   // welke foto nu in beeld staat, om niet te blijven scrollen

  function label(key) {
    // Liquid heeft deze teksten al ge-escaped; nog een keer zou &#39; opleveren.
    return Object.prototype.hasOwnProperty.call(cfg.strings || {}, key) ? cfg.strings[key] : '';
  }

  /* ── Ophalen ───────────────────────────────────────────────────────── */
  function load(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTION)
      .then(function (r) {
        if (!r.ok) throw new Error('niet gevonden');
        return r.text();
      })
      .then(function (html) { cache[handle] = html; return html; });
  }

  /** De PDP vult .ministars met een scriptje op [data-fill]; dat draait hier
      niet mee, dus doen we het na het injecteren zelf. Zelfde vulling: vijf
      sterren, per ster een percentage. */
  function fillStars() {
    var S = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l3 6.9 7.5.6-5.7 4.9 1.8 7.3L12 17.8 5.4 21.7l1.8-7.3L1.5 9.5 9 8.9z"/></svg>';
    body.querySelectorAll('[data-fill]').forEach(function (row) {
      var pct = parseFloat(row.getAttribute('data-fill')) || 0;
      var h = '';
      for (var i = 0; i < 5; i++) {
        var lo = i * 20, hi = (i + 1) * 20;
        var f = pct <= lo ? 0 : (pct >= hi ? 100 : (pct - lo) / 20 * 100);
        h += '<span class="star">' + S + '<span class="fill" style="width:' + f + '%">' + S + '</span></span>';
      }
      row.innerHTML = h;
    });
  }

  /** Maateenheid van de markt, gelijk aan de productpagina. Alleen de zichtbare
      tekst: data-v houdt de oorspronkelijke waarde, want daarmee wordt de
      variant gezocht. */
  function omgerekend(tekst) {
    var wortel = body.querySelector('[data-unit-default]');
    if (!wortel || wortel.getAttribute('data-unit-default') !== 'in' || !tekst) return tekst;
    function getal(a) { return parseFloat(a.replace(',', '.')); }
    function inch(v) { return (v / 2.54).toFixed(1).replace(/\.0$/, ''); }
    function pond(v) { return (v * 2.205).toFixed(1).replace(/\.0$/, ''); }
    var REEKS = /((?:[A-Za-zØø.]{0,5}\s*\d+(?:[.,]\d+)?\s*(?:[x×*\/-]\s*)?)+?)(mm|cm|kg)\b/gi;
    return tekst.replace(REEKS, function(m, groep, eenheid){
      var e = eenheid.toLowerCase();
      return groep
        .replace(/(\d+(?:[.,]\d+)?)/g, function(g, n){
          var v = getal(n);
          if(e === 'kg') return pond(v) + ' lbs';
          return inch(e === 'mm' ? v/10 : v) + '"';
        })
        .replace(/\s*[x×*\/]\s*/g, ' × ')
        .replace(/\s+$/, '');
    });
  }

  function pasEenhedenToe() {
    body.querySelectorAll('.cnv-convertible, .pill, .opt .val').forEach(function (el) {
      var t = omgerekend(el.textContent);
      if (t !== el.textContent) el.textContent = t;
    });
  }

  function readVariants() {
    var el = body.querySelector('[data-qa-variants]');
    variants = {};
    if (!el) return;
    try { variants = JSON.parse(el.textContent); } catch (e) { variants = {}; }
  }

  /** De op dit moment gekozen combinatie, of null als die niet bestaat. */
  function currentVariant() {
    var ids = Object.keys(variants);
    for (var i = 0; i < ids.length; i++) {
      var v = variants[ids[i]];
      var match = chosen.every(function (val, idx) {
        return val == null || v.options[idx] === val;
      });
      if (match) return { id: ids[i], data: v };
    }
    return null;
  }

  function readChosen() {
    chosen = [];
    body.querySelectorAll('.opt').forEach(function (group, i) {
      var on = group.querySelector('.sw.on, .pill.on');
      chosen[i] = on ? on.getAttribute('data-v') : null;
    });
  }

  /** Prijs, knop en labels bijwerken na een keuze. Alle bedragen zijn vooraf
      door Liquid opgemaakt, dus hier wordt geen valuta geraden. */
  function sync() {
    var hit = currentVariant();
    var price = body.querySelector('[data-qa-price]');
    var add = body.querySelector('[data-qa-add]');
    var addLabel = body.querySelector('[data-qa-add-label]');
    var addPrice = body.querySelector('[data-qa-add-price]');
    if (!hit || !add) return;

    var v = hit.data;
    if (price) {
      price.innerHTML =
        (v.compare ? '<del class="was">' + v.compare + '</del>' : '') +
        '<span class="now">' + (v.price_full || v.price) + '</span>' +
        (v.save ? '<span class="save">' + label('save').replace('__amount__', v.save) + '</span>' : '');
    }
    add.setAttribute('data-variant-id', hit.id);
    add.disabled = !v.available;
    if (addLabel) addLabel.textContent = v.available ? label('add_to_cart') : label('sold_out');
    if (addPrice) addPrice.textContent = v.price;

    showMediaFor(v);
  }

  /** Kies je een kleur, dan hoort de foto mee te gaan. Horizontaal op mobiel,
      verticaal op desktop — scrollIntoView volgt de richting van de strook. */
  function showMediaFor(v) {
    if (!v || !v.media_id || v.media_id === shownMedia) return;
    var shot = body.querySelector('[data-media-id="' + v.media_id + '"]');
    if (!shot) return;
    var first = shownMedia === null;      // bij openen niet animeren
    shownMedia = v.media_id;
    shot.scrollIntoView({
      behavior: first || reducedMotion() ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'center'
    });
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* ── Openen en sluiten ─────────────────────────────────────────────── */
  function open(handle, fromEl) {
    opener = fromEl || null;
    quantity = 1;
    shownMedia = null;
    root.hidden = false;
    void root.offsetHeight;              // reflow, anders slaat de transitie over
    root.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    body.innerHTML = '<div class="cnv-qa__loading">' + label('loading') + '</div>';

    load(handle).then(function (html) {
      body.innerHTML = html;
      fillStars();
      pasEenhedenToe();
      readVariants();
      readChosen();
      sync();
      // Naast de delegatie ook direct binden: zo werkt de knop ook als iets
      // anders op de pagina het event onderweg tegenhoudt.
      var addBtn = body.querySelector('[data-qa-add]');
      if (addBtn) addBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart();
      });
      var first = body.querySelector('.sw, .pill, [data-qa-add]');
      if (first) first.focus();
    }).catch(function () {
      body.innerHTML = '<div class="cnv-qa__loading">' + label('load_error') + '</div>';
    });
  }

  function close() {
    root.classList.remove('is-open');
    document.body.style.overflow = '';
    var done = function () {
      root.hidden = true;
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) done();
    else panel.addEventListener('transitionend', done, { once: true });
  }

  /* ── Toevoegen ─────────────────────────────────────────────────────── */
  function addToCart() {
    var add = body.querySelector('[data-qa-add]');
    var addLabel = body.querySelector('[data-qa-add-label]');
    var msg = body.querySelector('[data-qa-msg]');
    var id = add && add.getAttribute('data-variant-id');
    if (!id || add.disabled) return;

    add.disabled = true;
    if (addLabel) addLabel.textContent = label('adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('mislukt');
        return r.json();
      })
      .then(function (data) {
        if (addLabel) addLabel.textContent = label('added');
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        refreshCount();
        // Paneel dicht, winkelwagen open: je ziet meteen wat erin ligt.
        setTimeout(function () {
          close();
          openCartDrawer();
        }, 400);
      })
      .catch(function () {
        add.disabled = false;
        if (addLabel) addLabel.textContent = label('add_to_cart');
        if (msg) msg.textContent = label('add_error');
      });
  }

  /** De cart drawer is een custom element met een open()-methode. Bestaat hij
      niet (of is de winkelwagen op 'pagina' gezet), dan alleen de teller. */
  function openCartDrawer() {
    var drawer = document.querySelector('casanuva-cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;
    // Eerst de inhoud verversen, anders staat het zojuist toegevoegde artikel
    // er nog niet in. onCartUpdate houdt zelf bij of hij al open stond.
    drawer.open();
    if (typeof drawer.onCartUpdate === 'function') drawer.onCartUpdate();
  }

  /** Alleen de teller bijwerken: het paneel sluit, de winkel gaat door. */
  function refreshCount() {
    fetch(ROOT + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count], .cnv-header__cart-count, .casanuva-cart-count')
          .forEach(function (el) { el.textContent = cart.item_count; });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      })
      .catch(function () {});
  }

  /* ── Bediening ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-add]');
    if (trigger) {
      e.preventDefault();
      e.stopPropagation();               // de kaart is zelf een link
      open(trigger.getAttribute('data-quick-add'), trigger);
      return;
    }
    if (!root.contains(e.target)) return;

    if (e.target.closest('[data-qa-close]')) { close(); return; }

    var pick = e.target.closest('.sw, .pill');
    if (pick) {
      var group = pick.closest('.opt');
      group.querySelectorAll('.sw, .pill').forEach(function (x) { x.classList.remove('on'); });
      pick.classList.add('on');
      var shown = group.querySelector('.val');
      // Leestekst uit data-label (vertaald metaobject-label, zie casanuva-kleurnaam.liquid);
      // data-v blijft rauw want daarmee wordt de variant gezocht.
      if (shown) shown.textContent = omgerekend(pick.getAttribute('data-label') || pick.getAttribute('data-v'));
      readChosen();
      sync();
      return;
    }

    var qty = e.target.closest('[data-qa-qty]');
    if (qty) {
      quantity = Math.max(1, quantity + Number(qty.getAttribute('data-qa-qty')));
      var out = body.querySelector('[data-qa-qty-value]');
      if (out) out.textContent = quantity;
      return;
    }

    if (e.target.closest('[data-qa-add]')) addToCart();
  });

  root.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var focusable = panel.querySelectorAll('a[href], button:not([disabled]), .sw, .pill, [tabindex="0"]');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
